import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["titleComponent", "descriptionComponent"],
    _excluded2 = ["isSearchMode", "hasAdditionalLine", "searchInput"],
    _excluded3 = ["searchEnabled", "searchButtonProps", "isSearchMode", "toggleSearchMode", "children"],
    _excluded4 = ["searchInput"],
    _excluded5 = ["toggleSearchMode"];
import React, { useEffect, useState, useCallback, useContext } from "react";
import { isFunction, useThemeDefaults, isPropDefined } from "../utils";
import styled, { ThemeContext } from "styled-components";
import { flex, alignItems } from "styled-system";
import Box from "../Box";
import Link from "../Link";
import HR from "../HR";
import SearchIcon from "../Icons/SearchIcon";
var Left = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.sectionHeading.left.margin,
    minWidth: theme.sectionHeading.left.minWidth
  };
}, /*#__PURE__*/React.forwardRef(function (props, ref) {
  var titleComponent = props.titleComponent,
      descriptionComponent = props.descriptionComponent,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, rest), titleComponent);
}));
var Middle = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme;
  return {
    flex: theme.sectionHeading.middle.flex,
    margin: theme.sectionHeading.middle.margin
  };
}, styled( /*#__PURE__*/React.forwardRef(function (props, ref) {
  var isSearchMode = props.isSearchMode,
      hasAdditionalLine = props.hasAdditionalLine,
      searchInput = props.searchInput,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, rest), isSearchMode && !hasAdditionalLine && searchInput);
})).withConfig({
  displayName: "SectionHeading__Middle",
  componentId: "sc-1cm5qjt-0"
})(flex));
var Right = useThemeDefaults(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: theme.sectionHeading.right.display,
    justifyContent: theme.sectionHeading.right.justifyContent,
    alignItems: theme.sectionHeading.right.alignItems,
    margin: theme.sectionHeading.right.margin
  };
}, styled( /*#__PURE__*/React.forwardRef(function (props, ref) {
  var searchEnabled = props.searchEnabled,
      searchButtonProps = props.searchButtonProps,
      isSearchMode = props.isSearchMode,
      toggleSearchMode = props.toggleSearchMode,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded3);

  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(SearchButton, _extends({
    visibility: searchEnabled && !isSearchMode ? "visible" : "hidden",
    toggleSearchMode: toggleSearchMode
  }, searchButtonProps)), children);
})).withConfig({
  displayName: "SectionHeading__Right",
  componentId: "sc-1cm5qjt-1"
})(alignItems));
var AdditionalLine = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    width: theme.sectionHeading.additionalLine.width,
    margin: theme.sectionHeading.additionalLine.margin
  };
}, function (_ref5) {
  var searchInput = _ref5.searchInput,
      props = _objectWithoutProperties(_ref5, _excluded4);

  return /*#__PURE__*/React.createElement(Box, props, searchInput);
});

var _ref8 = /*#__PURE__*/React.createElement(SearchIcon, {
  transform: "translateY(3px)",
  width: "16px",
  height: "16px"
});

var SearchButton = useThemeDefaults(function (_ref6) {
  var theme = _ref6.theme;
  return {
    margin: theme.sectionHeading.searchButton.margin
  };
}, function (_ref7) {
  var toggleSearchMode = _ref7.toggleSearchMode,
      props = _objectWithoutProperties(_ref7, _excluded5);

  return /*#__PURE__*/React.createElement(Link, _extends({
    as: "button",
    onClick: toggleSearchMode
  }, props), _ref8);
});
export var ToolPulldown = useThemeDefaults(function (_ref9) {
  var theme = _ref9.theme;
  return {
    margin: theme.sectionHeading.toolPulldown.margin
  };
}, Box);
export var ToolButton = useThemeDefaults(function (_ref10) {
  var theme = _ref10.theme;
  return {
    margin: theme.sectionHeading.toolButton.margin
  };
}, Box);

var _ref11 = /*#__PURE__*/React.createElement(HR, null);

export var SectionHeading = function SectionHeading(props) {
  var theme = useContext(ThemeContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSearchMode = _useState2[0],
      setIsSearchMode = _useState2[1];

  useEffect(function () {
    if (isPropDefined(props.isSearchMode)) {
      setIsSearchMode(props.isSearchMode);
    }
  }, [props.isSearchMode]); // if there is no enough space to display search bar inline, it should appear in a new line

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasAdditionalLine = _useState4[0],
      setHasAdditionalLine = _useState4[1];

  var _useElementWidth = useElementWidth(),
      _useElementWidth2 = _slicedToArray(_useElementWidth, 2),
      outerWidth = _useElementWidth2[0],
      outerRef = _useElementWidth2[1];

  var _useElementWidth3 = useElementWidth(),
      _useElementWidth4 = _slicedToArray(_useElementWidth3, 2),
      leftWidth = _useElementWidth4[0],
      leftRef = _useElementWidth4[1];

  var _useElementWidth5 = useElementWidth(),
      _useElementWidth6 = _slicedToArray(_useElementWidth5, 2),
      rightWidth = _useElementWidth6[0],
      rightRef = _useElementWidth6[1];

  useEffect(function () {
    setHasAdditionalLine(outerWidth - leftWidth - rightWidth < 320);
  }, [outerWidth, leftWidth, rightWidth]);

  var toggleSearchMode = function toggleSearchMode() {
    if (isFunction(props.onSearchToggle)) {
      props.onSearchToggle(!isSearchMode);
    }

    setIsSearchMode(!isSearchMode);
  };

  var searchInput = props.renderSearch ? props.renderSearch({
    closeSearch: toggleSearchMode
  }) : null;
  var _props$searchButtonPr = props.searchButtonProps,
      searchButtonProps = _props$searchButtonPr === void 0 ? {} : _props$searchButtonPr;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    ref: outerRef,
    width: theme.sectionHeading.width,
    display: theme.sectionHeading.display,
    justifyContent: theme.sectionHeading.justifyContent,
    alignItems: theme.sectionHeading.alignItems,
    overflow: theme.sectionHeading.overflow
  }, /*#__PURE__*/React.createElement(Left, {
    ref: leftRef,
    titleComponent: props.titleComponent
  }), /*#__PURE__*/React.createElement(Middle, {
    isSearchMode: isSearchMode,
    hasAdditionalLine: hasAdditionalLine,
    searchInput: searchInput
  }), /*#__PURE__*/React.createElement(Right, {
    ref: rightRef,
    searchEnabled: !!searchInput,
    isSearchMode: isSearchMode,
    toggleSearchMode: toggleSearchMode,
    searchButtonProps: searchButtonProps
  }, props.children)), isSearchMode && hasAdditionalLine && /*#__PURE__*/React.createElement(React.Fragment, null, _ref11, /*#__PURE__*/React.createElement(AdditionalLine, {
    searchInput: searchInput,
    toggleSearchMode: toggleSearchMode
  })));
};

var useElementWidth = function useElementWidth() {
  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      width = _useState6[0],
      setWidth = _useState6[1];

  var ref = useCallback(function (node) {
    if (node !== null) {
      setWidth(node.getBoundingClientRect().width);
    }
  });
  return [width, ref];
};

SectionHeading.ToolPulldown = ToolPulldown;
SectionHeading.ToolButton = ToolButton;
export default SectionHeading;